import { Injectable, inject } from '@angular/core';
import { CrudService } from '../../crud/crud.service';
import { firstValueFrom, from, Observable, of, switchMap } from 'rxjs';
import { AdministrationUser, User } from 'src/app/models/user';
import { AuthService } from '@core/auth/services/auth.service';
import { FirebaseAuthProvider } from '../providers/firebase/FirebaseAuthProvider';
import { FirebaseLibService } from '@shared/modules/firebase/firebase-lib.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    model = 'users';
    private crudService = inject(CrudService);
    private auth = inject(AuthService);
    private firebaseProvider = inject(FirebaseAuthProvider);
     firebaseService = inject(FirebaseLibService);

    getOne(id: string) {
        this.crudService.setModel(this.model);
        return this.crudService.findFirst(id);
    }

    getAccount(id: string, userType: string) {
        const path = this.model + '/' + id + '/accounts/' + userType;
        this.crudService.setModel(path);
        return this.crudService.findFirst<any>('');
    }

    update(id: string, data: any, userType: string) {
        const path = this.model + '/' + id + '/accounts/' + userType;
        this.crudService.setModel(path);
        return this.crudService.update('', data);
    }

    getCurrentUser(): Promise<User | null> {
        this.auth.provider = this.firebaseProvider;
        return this.auth.getCurrentUser();
    }

    getLoggedUser(): Observable<User | null> {
        this.auth.provider = this.firebaseProvider;
        return from(this.auth.getLoggedUser())
    }

    getCurrentAdministrationUser(): Promise<AdministrationUser | null> {
        this.auth.provider = this.firebaseProvider;
        return this.auth.getCurrentUser();
    }

    searchAdministratorByName() {
        let result=of([]);

        let wheres=[
            {field:'type',operator:'==',value:'administration'}
        ];

        result=this.firebaseService.getUserByQuery({
            where:wheres,
            order:[]
        });

        return result;
    }
    searchAdministratorByadministrationWsp(wsp: string) {
        let result=of([]);

        let wheres=[
            {field:'type',operator:'==',value:'administration'},
            {field:'administrationWsp',operator:'==',value:wsp}
        ];

        result=this.firebaseService.getUserByQuery({
            where:wheres,
            order:[]
        });

        return result;
    }

    createBK(data: any) {
        const path = 'usuariosadminbk';
        this.crudService.setModel(path);
        return this.crudService.add(data);
    }

}
